import * as storage from './storage';
import { buildApiUrl } from './apiHelper';

export default async function trackConversion(action, subPage) {
    let tracked = storage.get('tracked') ? storage.get('tracked') : [];
    if (!!~tracked.indexOf(action + '_' + subPage)) {
        return;
    }
    tracked.push(action + '_' + subPage);
    storage.set('tracked', tracked);

    let mode = 'web';
    if (storage.get('mode') !== null) {
        mode = storage.get('mode');
    }

    await fetch(buildApiUrl(window.$serviceUrl, `/claim/trackConversion/${JSON.parse(storage.get('bookingNumber'))}`), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: action,
            subPage: subPage,
            mode: mode,
            affiliate: window.$affiliate === 'ch24',
        }),
    }).catch(() => {});
}
